import { ROLE_REQUEST, ROLE__SUCCESS, ROLE_ERROR } from './role.type'

import ApiRest from '@/api/api-rest'

const state = {
  userRolesStatus: '',
  userRoleList: null
}

const getters = {
  userRolesStatus: state => state.userRolesStatus,
  userRoleList: state => state.userRoleList
}

// Best Practice - updates state
const mutations = {
  [ROLE_REQUEST]: state => (state.userRolesStatus = 'loading'),
  [ROLE__SUCCESS]: (state, data) => {
    state.userRolesStatus = 'saved'
    state.userRoleList = data
  },
  [ROLE_ERROR]: (state, errMsg) => {
    state.userRolesStatus = 'error'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [ROLE_REQUEST] (context) {
    return new Promise((resolve, reject) => {
      context.commit(ROLE_REQUEST)
      ApiRest()
        .get('/roles')
        .then(resp => {
          if (!resp) {
            resp = { data: [] }
          }
          context.commit(ROLE__SUCCESS, resp.data)
          resolve(resp)
        })
        .catch(errMsg => {
          context.commit(ROLE_ERROR, errMsg)
          reject(errMsg)
        })
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/role/role.module.js